import { RouteMapper } from '@/javascript/infra/mappers/route-mapper'
import { RouteMemberMapper } from '@/javascript/infra/mappers/route-member-mapper'
import { RoutePointMapper } from '@/javascript/infra/mappers/route-point-mapper'

export const makeRouteMapper = (): RouteMapper => {
  const pointMapper = new RoutePointMapper()
  const memberMapper = new RouteMemberMapper(pointMapper)
  return new RouteMapper(memberMapper)
}
